import { render, staticRenderFns } from "./BillTable.vue?vue&type=template&id=23c8431b&scoped=true&"
import script from "./BillTable.vue?vue&type=script&lang=js&"
export * from "./BillTable.vue?vue&type=script&lang=js&"
import style0 from "./BillTable.vue?vue&type=style&index=0&id=23c8431b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8431b",
  null
  
)

export default component.exports